import { CssBaseline, ThemeProvider } from '@mui/material';
import { AppRoutes } from 'Routes';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RestoreConnection } from 'modules/auth';
import { CustomizedSnackbarProvider } from 'modules/notifications';
import { darkTheme } from 'modules/themes';
import { Provider } from 'react-redux';
import { store } from 'store';
import packageJson from '../package.json';
import { useInitializeLocale } from 'modules/i18n';
import { QueryLoading } from 'modules/common/components/QueryLoading';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export function App() {
  const { isInitialized } = useInitializeLocale();

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={packageJson.homepage}>
          <ThemeProvider theme={darkTheme}>
            <CssBaseline />

            <CustomizedSnackbarProvider />

            {isInitialized ? (
              <>
                <RestoreConnection />

                <AppRoutes />
              </>
            ) : (
              <QueryLoading isAbsolute />
            )}
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
}
